import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Invoice: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m255.56 629.75c-38.29 0-69.43-31.15-69.43-69.44s31.15-69.44 69.43-69.44 69.44 31.15 69.44 69.44-31.15 69.44-69.44 69.44zm0-108.87c-21.74 0-39.43 17.69-39.43 39.44s17.69 39.44 39.43 39.44 39.44-17.69 39.44-39.44-17.69-39.44-39.44-39.44z' />
    <path d='m360 690h-30c0-33.08-33.92-60-75.62-60s-75.62 26.92-75.62 60h-30c0-24.58 11.36-47.52 31.98-64.59 19.8-16.39 45.95-25.41 73.64-25.41s53.84 9.02 73.64 25.41c20.62 17.07 31.98 40 31.98 64.59z' />
    <path d='m600 660.16h-100v-30h70v-345h30z' />
    <path d='m210 480h-30v-359.83h255v29.99h-225z' />
    <path d='m585 300.16h-150c-8.28 0-15-6.72-15-15v-150c0-6.07 3.65-11.54 9.26-13.86 5.6-2.32 12.06-1.04 16.35 3.25l150 150c4.29 4.29 5.57 10.74 3.25 16.35-2.32 5.6-7.79 9.26-13.86 9.26zm-135-30h98.79l-98.79-98.79z' />
    <path d='m380.08 660.16h154.92s0-30 0-30h-124.92c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

Invoice.displayName = 'Invoice';

export default Invoice;
